import { Amplify } from 'aws-amplify';
import { EnvironmentService } from 'shared/services';
import { Pool } from './config';

const configureAmplify = (pool: Pool) => {
  const { oauth, ...rest } = pool;
  const awsEndpointUrl = EnvironmentService.getVariable('AWS_ENDPOINT_URL');

  Amplify.configure({
    Auth: {
      ...rest,
      region: 'eu-west-1',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH' as const,
      ...(awsEndpointUrl ? { endpoint: awsEndpointUrl } : {}),
      ...(oauth ? { oauth } : {}),
    },
  });
};

export { configureAmplify };
